import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/decades.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for makes
  const mock = AxiosMock.getInstance();
  mock.onGet("/carburate/market/decades/").reply(200, data);
}

export const getMarketDecades = async () => {
  return api.get("/carburate/market/decades/") as Promise<string[]>;
};

export const getMarketDecadesQueryOptions = () => {
  return queryOptions({
    queryKey: ["market", "decades"],
    queryFn: getMarketDecades,
  });
};

type UseMarketDecadesOptions = {
  queryConfig?: QueryConfig<typeof getMarketDecades>;
};

export const useMarketDecades = ({ queryConfig }: UseMarketDecadesOptions = {}) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getMarketDecadesQueryOptions(),
    ...queryConfig,
  });
};
